<ng-container *transloco="let t; read: 'partials.agenda.blocks.exercise'">
  <div *ngIf="container?.exercise" class="agenda-block" [class.active]="container?.exercise?.isActive === true">
    <app-agenda-exercise-headline
      [container]="container"
      [type]="'exercise'"
      [title]="container.name"
      [group]="ac?.isGroup()"
      [team]="container?.exercise?.isTeam()"
    ></app-agenda-exercise-headline>
    <div *ngIf="container?.opened === true" class="exercise-content">
      <app-agenda-exercise-single
        *ngIf="ac?.isSingle()"
        [container]="container"
        ></app-agenda-exercise-single>
        <app-agenda-exercise-group
        *ngIf="ac?.isGroup()"
        [container]="container"
      ></app-agenda-exercise-group>
    </div>
  </div>
</ng-container>
